/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

export { getServerCacheScope } from '@/data/cache/getServerCacheScope';
